const linktree = document.querySelector('.linktree');
const linktreeItems =
  linktree && linktree.querySelectorAll('.linktree-menu__item');

if (linktree) {
  window.addEventListener('DOMContentLoaded', () => {
    linktree.classList.add('linktree--animate');
    linktreeItems.forEach((item, idx) => {
      item.style.animationDelay = `${idx * 300}ms`;
    });
  });
}
